import {
  inject,
  Injectable,
} from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';
import {
  ConversationApiService,
  CreateConversationRequest,
  ConversationChannel,
  Participant,
  ParticipantType,
  PlatformLocation,
} from '@vendasta/conversation';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Row } from '@vendasta/galaxy/table';
import {
  CrmFieldService,
  StandardExternalIds,
} from '@galaxy/crm/services/field-service';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root',
})
export class InboxService {
  private readonly auth = inject(AuthService);
  private readonly conversationApi = inject(ConversationApiService);
  private readonly router = inject(Router);
  private readonly snackbar = inject(SnackbarService);
  private readonly crmFields = inject(CrmFieldService);

  async goToContactConversation(
    namespace: string,
    parentNamespace: string,
    contactId: string,
    channel: ConversationChannel,
  ) {
    const participantOrganization = new Participant({
      participantType: ParticipantType.PARTICIPANT_TYPE_ACCOUNT_GROUP,
      accountGroupId: namespace,
      partnerId: parentNamespace,
      internalParticipantId: '',
      isSubjectParticipant: true,
    });
    const participantContact = new Participant({
      participantType: ParticipantType.PARTICIPANT_TYPE_CUSTOMER,
      accountGroupId: namespace,
      partnerId: parentNamespace,
      internalParticipantId: contactId,
      isSubjectParticipant: true,
    });
    const participantSender = new Participant({
      participantType: ParticipantType.PARTICIPANT_TYPE_IAM_USER,
      accountGroupId: namespace,
      partnerId: parentNamespace,
      internalParticipantId: this.auth.effectiveUserId(),
      isSubjectParticipant: false,
    });
    const createReq = new CreateConversationRequest({
      participants: [participantOrganization, participantContact, participantSender],
      channel: channel,
      originLocation: PlatformLocation.PLATFORM_LOCATION_BUSINESS_APP,
    });
    try {
      const response = await firstValueFrom(this.conversationApi.createConversation(createReq));
      const path = `/account/location/${namespace}/inbox/channel/${response.conversation.conversationId.replaceAll('CONVERSATION-', '')}`;
      this.router.navigateByUrl(path);
    } catch (error) {
      this.snackbar.openErrorSnack('CRM.CONVERSATION_CREATE_ERROR');
    }
  }

  getContactPhoneFromRow(row: Row): string {
    const phoneFieldId = this.getContactPhoneFieldId();
    return row.data[phoneFieldId]?.value;
  }

  private getContactPhoneFieldId(): string {
    return this.crmFields.getFieldId(StandardExternalIds.PhoneNumber);
  }
}
